import { ModelBase } from "./base";
import { Address } from "./address";

export class Order extends ModelBase{
    store_uuid: string;
    customer_uuid?: string;
    firstname?: string;
    lastname?: string;
    emailaddress?: string;
    phonenumber?: string;
    delivery_method_uuid: string;
    payment_method_uuid: string;
    orderLines: Array<OrderLine>;
    invoiceAddress: Address;
    deliveryAddress: Address;
    remarks: string;
}

export class OrderLine {
    product_id: string;
    quantity: number;
    price_inc_vat: number;
    price_ex_vat: number;
    // options: Array<OrderLineOption>;
}

export class OrderLineOption {
    option_id: number;
    quantity: number;
}


// WEBPACK FOOTER //
// ./src/models/order.ts